// src/pages/expense/cafe/ExpenseCafeDoksanDraftList.jsx
// ✅ 전 사업 확산 [5] — 카페인 독산점 "지출목록" 페이지. 실제 로직은
// pages/expense/_shared/ExpenseDraftList.jsx(공통 컴포넌트)에 있고, 이 파일은
// 독산점 전용 config(doksanDraftConfig.js)를 넘기는 얇은 래퍼일 뿐이다.
import React from "react";
import ExpenseDraftList from "../_shared/ExpenseDraftList";
import doksanDraftConfig from "./doksanDraftConfig";

export default function ExpenseCafeDoksanDraftList() {
  return <ExpenseDraftList config={doksanDraftConfig} />;
}
